import { useMemo } from 'react';
import {
  RowId,
  startEndSettingUseFieldName,
  SmartSuggestionSettingUseFieldName
} from '../constant';
import { mapToUiAccessSope } from '../utils';
import { EnabledDisabled } from './../constant';
import {
  GroupType,
  StartEndSettings,
  SmartSuggestionSettings
} from './../../../graphql/types';
const mapToDefaultValues = (rows: any) => {
  return rows?.slice(0, -1).map((s: any) => {
    return {
      enableDisabled: s.enabled
        ? EnabledDisabled.enabled
        : EnabledDisabled.disabled,
      [GroupType.Department]:
        mapToUiAccessSope(s.accessScopeIn?.departmentGroups) ?? [],
      [GroupType.EmployeeType]:
        mapToUiAccessSope(s.accessScopeIn?.employeeTypeGroups) ?? [],
      [GroupType.Location]: mapToUiAccessSope(s.accessScopeIn?.locations) ?? [],
      [GroupType.Division]: mapToUiAccessSope(s.accessScopeIn?.divisions) ?? [],
      [GroupType.CostCenter]:
        mapToUiAccessSope(s.accessScopeIn?.costCenters) ?? [],
      [GroupType.ServiceCenter]:
        mapToUiAccessSope(s.accessScopeIn?.serviceCenters) ?? []
    };
  });
};

export const useGetStartEndDefaultValues: any = (
  settings: StartEndSettings[]
) => {
  return useMemo(() => {
    const rows = mapToDefaultValues(settings);
    return {
      defaultValues: {
        name: RowId,
        [startEndSettingUseFieldName]: rows,
        defaultEnabled: settings?.length
          ? settings[settings!.length - 1].enabled
            ? EnabledDisabled.enabled
            : EnabledDisabled.disabled
          : EnabledDisabled.enabled
      }
    };
  }, [settings]);
};

export const useGetSmartSuggestionDefaultValues: any = (
  settings: SmartSuggestionSettings[]
) => {
  return useMemo(() => {
    const rows = mapToDefaultValues(settings);
    return {
      defaultValues: {
        name: RowId,
        [SmartSuggestionSettingUseFieldName]: rows,
        defaultEnabled: settings?.length
          ? settings[settings!.length - 1].enabled
            ? EnabledDisabled.enabled
            : EnabledDisabled.disabled
          : EnabledDisabled.enabled
      }
    };
  }, [settings]);
};
